// extracted by mini-css-extract-plugin
export var avatarContainer = "_b8-0";
export var avatarTypingWave = "_b8-i";
export var gray = "_b8-f";
export var green = "_b8-c";
export var icon = "_b8-9";
export var image = "_b8-1";
export var lg = "_b8-6";
export var md = "_b8-5";
export var presenceDot = "_b8-b";
export var red = "_b8-d";
export var sm = "_b8-4";
export var status = "_b8-a";
export var typingDot = "_b8-h";
export var typingPill = "_b8-g";
export var xl = "_b8-7";
export var xs = "_b8-3";
export var xxl = "_b8-8";
export var xxs = "_b8-2";
export var yellow = "_b8-e";